import fetch from "auth/FetchInterceptor";
import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_REFRESH,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  AUTH_WHOAMI,
  AUTH_VERIFY_2FA,
  AUTH_VERIFY_2FA_RESEND_OTP,
  AUTH_VERIFY_2FA_BACKUP_CODE,
  TWO_FA_SETUP,
  TWO_FA_CONFIRM,
  TWO_FA_DISABLE,
  TWO_FA_DISABLE_SEND_OTP,
  TWO_FA_BACKUP_CODES_GENERATE,
  TWO_FA_BACKUP_CODES_DOWNLOAD,
  ORG_2FA_ENFORCEMENT,
} from "constants/ApiConstant";

const AuthService = {};

AuthService.login = function (data) {
  return fetch({
    url: AUTH_LOGIN,
    method: "post",
    data: data,
  });
};

AuthService.logout = function () {
  return fetch({
    url: AUTH_LOGOUT,
    method: "post",
  });
};

AuthService.forgotPassword = function (data) {
  return fetch({
    url: FORGOT_PASSWORD,
    method: "post",
    data: data,
  });
};

AuthService.refreshToken = function () {
  return fetch({
    url: AUTH_REFRESH,
    method: "post",
  });
};

AuthService.resetPassword = function (data) {
  return fetch({
    url: RESET_PASSWORD,
    method: "post",
    data: data,
  });
};

AuthService.whoami = function () {
  return fetch({
    url: AUTH_WHOAMI,
    method: "get",
  });
};

AuthService.verify2FALogin = function (data) {
  return fetch({
    url: AUTH_VERIFY_2FA,
    method: "post",
    data: data,
  });
};

AuthService.resend2FALoginOtp = function (data) {
  return fetch({
    url: AUTH_VERIFY_2FA_RESEND_OTP,
    method: "post",
    data: data,
  });
};

AuthService.setup2FA = function (data) {
  return fetch({
    url: TWO_FA_SETUP,
    method: "post",
    data: data,
  });
};

AuthService.confirm2FA = function (data) {
  return fetch({
    url: TWO_FA_CONFIRM,
    method: "post",
    data: data,
  });
};

AuthService.disable2FA = function (data) {
  return fetch({
    url: TWO_FA_DISABLE,
    method: "post",
    data: data,
  });
};

AuthService.sendDisable2FAOtp = function () {
  return fetch({
    url: TWO_FA_DISABLE_SEND_OTP,
    method: "post",
  });
};

AuthService.verify2FALoginBackupCode = function (data) {
  return fetch({
    url: AUTH_VERIFY_2FA_BACKUP_CODE,
    method: "post",
    data: data,
  });
};

AuthService.generate2FABackupCodes = function () {
  return fetch({
    url: TWO_FA_BACKUP_CODES_GENERATE,
    method: "post",
  });
};

AuthService.download2FABackupCodes = function () {
  return fetch({
    url: TWO_FA_BACKUP_CODES_DOWNLOAD,
    method: "get",
    responseType: "blob",
  });
};

AuthService.updateOrg2FAEnforcement = function (orgId, data) {
  return fetch({
    url: ORG_2FA_ENFORCEMENT(orgId),
    method: "patch",
    data: data,
  });
};

export default AuthService;
